document.addEventListener("DOMContentLoaded", function() {
    var subscribeButtons = document.querySelectorAll('.subscribe-btn');

    subscribeButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            var popup = document.getElementById("shopify-section-sections--23524563714365__popup");

            // 检查弹窗是否存在
            if (popup) {
                popup.style.display = "block"; // 显示弹窗
            } else {
                console.error("Popup element not found!"); // 记录错误
            }
        });
    });
});